import React, { useState, useEffect } from 'react';
import { Button,App ,Modal} from 'antd';
import styles from './index.module.scss';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { getCarpoolById, getDeliveryById,carpoolConfirmOrder } from '@/api/car';
import OrderDialogCar, { OrderDialogOrder, OrderDialogMode } from '@/components/OrderDialogCar/OrderDialogCar';
import { OrderItem } from '@/pages/YourTownloop/Subroute/PostOrders/order';
import dayjs from 'dayjs';
import { createChatRoom } from '@/api/message';


interface YourTownloopOrdersListProps {
  orderItem: OrderItem;
  getId?: (id: string, action: string) => void;
  type?: 'ride' | 'delivery';
  isPoster?: boolean;//true是订单发布者 false是司机接单人
}

const CarpoolServiceDetail: React.FC<YourTownloopOrdersListProps> = ({ orderItem, getId, type,isPoster=true }) => {
  const navigate = useNavigate();
  const { message } = App.useApp();
  const params = useParams(); // 获取URL参数

  const [searchParams] = useSearchParams();

  // 辅助函数：格式化日期
  const formatDate = (date: string | dayjs.Dayjs | undefined): string => {
    if (!date) return '';
    if (typeof date === 'string') return date;
    return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
  };

  // 转换OrderItem为OrderDialogOrder兼容的格式
  const convertToDialogOrder = (data: OrderItem): OrderDialogOrder => {
    return {
      ...data,
      departure_date: data.departure_date,
      pickup_time: data.pickup_time,
      expected_delivery_time: data.expected_delivery_time,
    };
  };

 

  const [mapUrl, setMapUrl] = useState<string>('')



  //是否是送货 - 优先使用传入的type，否则从URL参数获取
  const isDelivery = type === 'delivery';

  const currentData = orderItem ;

  // 联系车主
  const contactTheMaster = () => {
    console.log('contactTheMaster');
    createChatRoom({ member_id: currentData?.partner_user_id || '' }).then((res) => {
      if (res.code == 200) {
        navigate(`/chatList?chatRoomId=${res.data.room_id}`);
      } else {
        message.error(res.message);

      }
    });
  };

  // 确认订单
  const confirmOrder = () => {

    //是否确认订单
    Modal.confirm({
      title: 'Confirm the order',
      content: 'Are you sure you want to confirm the order?',
      onOk: async () => {
        console.log('confirmOrder');
        carpoolConfirmOrder({order_id: (currentData.carpool_order_id || currentData.delivery_order_id) as string}).then((res) => {
          if(res.code === 200){
            message.success('Confirm the order successfully');
            //刷新当前页面
            getId && getId((currentData.carpool_order_id || currentData.delivery_order_id) as string, 'confirm');
            //关闭当前弹窗
       
          }else{
            message.error(res.message);
          }
        });

      }
    });
   
    
  };
  
  //提交竞价
  const handleConfirm = () => {
  };
  // 竞价和一口价弹窗

  useEffect(() => {
    const start = currentData.starting_point_address + ',' + currentData.starting_point_city + ',' + currentData.starting_point_state;
    const destination = currentData.destination_point_address + ',' + currentData.destination_point_city + ',' + currentData.destination_point_state;
    //debugger
    const mapQuery = encodeURIComponent(`${start} to ${destination}`);
    const mapUrl2 = `https://www.google.com/maps?output=embed&q=${mapQuery}`;

    setMapUrl(mapUrl2);
  }, [currentData])



  useEffect(() => {
   

  }, [params.id, orderItem, searchParams, type])



  return (
    <div className={styles['detail-page']}>
      <div className={styles['info-card']}>


        <ul className={styles['route-list']}>
          <li>
            <span className={styles['label-strong']}>Starting Point:</span>
            <span className={styles['text']}>{currentData.starting_point_address + ',' + currentData.starting_point_city + ',' + currentData.starting_point_state}</span>
          </li>
          <li>
            <span className={styles['label-strong']}>Destination:</span>
            <span className={styles['text']}>{currentData.destination_point_address + ',' + currentData.destination_point_city + ',' + currentData.destination_point_state}</span>
          </li>
        </ul>

        <div className={styles['miles-row']}>
          <span className={styles['dot']}></span>
          {currentData.distance || 2.5} Miles From You
        </div>

        <div className={styles['divider']} />

        {/* 拼车送人 */}
        {
          !isDelivery && (
            <>
              <div className={styles['row']}>
                <span className={styles['label']}>Departure:</span>
                <span className={styles['value']}>{formatDate(currentData.departure_date)}</span>
              </div>
              <div className={styles['row']}>
                <span className={styles['label']}>Seats Needed:</span>
                <span className={styles['value']}>{currentData.seats_needed} People</span>
              </div>
              <div className={styles['row']}>
                <span className={styles['label']}>Luggage:</span>
                <span className={styles['value']}>{currentData.has_luggage ? 'Has Luggage' : 'No Luggage'}</span>
              </div>
              <div className={styles['row']}>
                <span className={styles['label']}>Service Requirements:</span>
                <span className={styles['value']}>{currentData.service_requirements}</span>
              </div>

              <div className={styles['row']}>
                <span className={styles['label']}>Notes:</span>
                <span className={styles['value']}>{currentData.notes}</span>
              </div>
            </>
          )
        }

        {/* 拼车送货 */}
        {
          isDelivery&&(
            <>
              <div className={styles['row']}>
                <span className={styles['label']}>Pickup Time:</span>
                <span className={styles['value']}>{formatDate(currentData.pickup_time)}</span>
              </div>
              <div className={styles['row']}>
                <span className={styles['label']}>Expected Delivery Time:</span>
                <span className={styles['value']}>{formatDate(currentData.expected_delivery_time)}</span>
              </div>
              <div className={styles['row']}>
                <span className={styles['label']}>Item Description:</span>
                <span className={styles['value']}>{currentData.item_description}</span>
              </div>
              <div className={styles['row']}>
                <span className={styles['label']}>Quantity:</span>
                <span className={styles['value']}>{currentData.quantity}</span>
              </div>

              <div className={styles['row']}>
                <span className={styles['label']}>Package Size:</span>
                <span className={styles['value']}>{currentData.package_size}</span>
              </div>
              <div className={styles['row']}>
                <span className={styles['label']}>Package Weight:</span>
                <span className={styles['value']}>{currentData.package_weight}</span>
              </div>
              <div className={styles['row']}>
                <span className={styles['label']}>Notes:</span>
                <span className={styles['value']}>{currentData.notes}</span>
              </div>
            </>
          )
        }
        <div className={styles['price-row']}>
          <span className={styles['price-label']}>Price:</span>
          <span className={styles['price']}>${currentData.final_price}</span>
        </div>

        <div className={styles['actions']}>
          <Button
            className={styles['btn-outline']}
            style={{minWidth:isPoster?"160px":"230px"}}
            onClick={() => contactTheMaster()}
          >Contact the master</Button>
          {/* 发布人确认订单 */}
          {
            isPoster && (
              <Button
                className={styles['btn-primary']}
                onClick={() => confirmOrder()}
              >Confirm the order</Button>
            )
          }
          
        </div>
      </div>

      <div className={styles['map-card']}>
        <iframe
          className={styles['map-iframe']}
          src={mapUrl}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="route-map"
        />
      </div>

      
    </div>
  );
};

export default CarpoolServiceDetail; 